module.exports = __webpack_public_path__ + "media/images/fb-logo-grey-e591fa08.png";